__turbopack_context__.v({
  "emptyContainer": "Suggestions-module-scss-module__Lyr31G__emptyContainer",
  "loaderContainer": "Suggestions-module-scss-module__Lyr31G__loaderContainer",
  "sectionContainer": "Suggestions-module-scss-module__Lyr31G__sectionContainer",
});
